/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCarveOutRequest
 */
export interface UpdateCarveOutRequest {
    /**
     * 
     */
    medication_name?: string;
    /**
     * 
     */
    dosage?: string;
    /**
     * 
     */
    route?: string;
    /**
     * 
     */
    frequency?: string;
    /**
     * Pass null to clear a previously set cost.
     */
    cost_per_day?: number | null;
    /**
     * 
     */
    j_code?: string;
    /**
     * 
     */
    ndc?: string;
    /**
     * Pass null to clear a previously set stop date.
     */
    stop_date?: string | null;
    /**
     * 
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateCarveOutRequest interface.
 */
export function instanceOfUpdateCarveOutRequest(value: object): value is UpdateCarveOutRequest {
    return true;
}

export function UpdateCarveOutRequestFromJSON(json: any): UpdateCarveOutRequest {
    return UpdateCarveOutRequestFromJSONTyped(json, false);
}

export function UpdateCarveOutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCarveOutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'medication_name': json['medication_name'] == null ? undefined : json['medication_name'],
        'dosage': json['dosage'] == null ? undefined : json['dosage'],
        'route': json['route'] == null ? undefined : json['route'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'cost_per_day': json['cost_per_day'] === undefined ? undefined : json['cost_per_day'] === null ? null : json['cost_per_day'],
        'j_code': json['j_code'] == null ? undefined : json['j_code'],
        'ndc': json['ndc'] == null ? undefined : json['ndc'],
        'stop_date': json['stop_date'] === undefined ? undefined : json['stop_date'] === null ? null : json['stop_date'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateCarveOutRequestToJSON(json: any): UpdateCarveOutRequest {
    return UpdateCarveOutRequestToJSONTyped(json, false);
}

export function UpdateCarveOutRequestToJSONTyped(value?: UpdateCarveOutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'medication_name': value['medication_name'],
        'dosage': value['dosage'],
        'route': value['route'],
        'frequency': value['frequency'],
        'cost_per_day': value['cost_per_day'],
        'j_code': value['j_code'],
        'ndc': value['ndc'],
        'stop_date': value['stop_date'],
        'notes': value['notes'],
    };
}

